import { faDatabase } from "@fortawesome/pro-regular-svg-icons/faDatabase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Stack, Typography } from "@mui/material";
import { MprcLink } from "components";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "../../CardBuilder";
import { DefaultOptions } from "../common/DefaultOptions";
import { WhoViewButton } from "../common/Interaction";


const ViewQuestionButton = () => {
    const { pub: { publicationId } } = useCardContext();
    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();
    return (
        <MprcLink variant="body1" color="primary.light" onClick={() => navigate(KnowledgePaths.QuestionViewer(publicationId))}>
            {t("Feed.Card.Question.ViewQuestionButtonText")}
        </MprcLink>
    );
};

export const PublicationAdminFooter = () => {

    const { pub: { otherInfo: { totalStorageSize } } } = useCardContext();
    const { t } = useTranslation("knowledge");

    const StorageSizeBox =
        <Typography variant={"iconText"} component="div">
            <Stack spacing={1} direction="row" alignItems="center">
                <FontAwesomeIcon icon={faDatabase} title={t("Feed.PublicationAdmin.StorageSizeTooltip")} />
                <span> {Formaters.fileSize(totalStorageSize)}</span>
            </Stack>
        </Typography>;

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <ViewQuestionButton />
            </Grid>
            <Grid>
                <Grid container spacing={3} alignItems="center" justifyContent="center">
                    <Grid>
                        <WhoViewButton />
                    </Grid>
                    <Grid>
                        {totalStorageSize > 0 && StorageSizeBox}
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <DefaultOptions />
            </Grid>
        </Grid>
    );
};
